module.exports = __webpack_public_path__ + "static/media/Header 1.9eec2842.svg";